import {
	hideLoadingScreen,
	router,
	setPageContent,
	showLoadingScreen,
} from "..";
import { postUser } from "../api/users";
import { config } from "../app-env/common";
import { locale } from "../locale";
import { Bulma } from "../view/bulma";
import { centeredBox, countrySelect, passwordInput } from "../view/components";

function createAccountPage() {
	const email = Bulma.input({
		type: "email",
	});

	const password = passwordInput();

	const country = countrySelect();

	const name = Bulma.input({
		type: "text",
	});

	const addr1 = Bulma.input({
		type: "text",
	});

	const addr2 = Bulma.input({
		type: "text",
	});

	const postalCode = Bulma.input({
		type: "text",
	});

	const town = Bulma.input({
		type: "text",
	});

	const vatin = Bulma.input({
		type: "text",
	});

	const onclickCreateAccount = () => {
		showLoadingScreen();
		postUser({
			email: email.getValue(),
			password: password.getValue(),
			country: country.getValue(),
			name: name.getValue(),
			addr1: addr1.getValue(),
			addr2: addr2.getValue(),
			postalCode: postalCode.getValue(),
			town: town.getValue(),
			vatin: vatin.getValue(),
		})
			.then(() => {
				if (config.appId === "test.my.luda.farm") {
					router.jump("/sign-in");
				} else {
					router.jump(`/verify-account?email=${email.getValue()}`);
				}
			})
			.finally(hideLoadingScreen);
	};

	setPageContent(
		centeredBox(
			"small",
			Bulma.title(locale.strings.createAccount),
			document.createElement("hr"),

			Bulma.title(
				locale.string({
					enGB: "Step 1: Enter the required account details.",
					deDE: "Schritt 1: Geben Sie die erforderlichen Kontodaten ein.",
					frFR: "Étape 1 : Saisir les informations requises sur le compte.",
					svSE: "Steg 1: Ange de nödvändiga kontouppgifterna.",
				}),
				"is-6",
			),
			Bulma.field(
				{},
				Bulma.label(locale.strings.email),
				Bulma.control({}, email.element),
			),
			Bulma.field(
				{},
				Bulma.label(locale.strings.password),
				password.element,
			),
			Bulma.field(
				{},
				Bulma.label(locale.strings.country),
				Bulma.control({}, country.element),
			),
			document.createElement("hr"),

			Bulma.title(
				locale.string({
					enGB: "Step 2 (optional): Add additional information to be included on your invoices. You may skip this step and add the details later via the billing menu. ",
					deDE: "Schritt 2 (optional): Fügen Sie zusätzliche Informationen hinzu, die auf Ihren Rechnungen erscheinen sollen. Sie können diesen Schritt überspringen und die Details später über das Rechnungsmenü hinzufügen. ",
					frFR: "Étape 2 (facultative) : Ajoutez des informations supplémentaires à inclure dans vos factures. Vous pouvez sauter cette étape et ajouter les détails plus tard via le menu de facturation. ",
					svSE: "Steg 2 (valfritt): Lägg till ytterligare information som ska finnas med på dina fakturor. Du kan hoppa över det här steget och lägga till informationen senare via betalningsmenyn. ",
				}),
				"is-6",
			),
			Bulma.field(
				{},
				Bulma.label(locale.strings.name),
				Bulma.control({}, name.element),
			),
			Bulma.field(
				{},
				Bulma.label(
					locale.string({
						enGB: "Address line 1",
						deDE: "Adresszeile 1",
						frFR: "Adresse ligne 1",
						svSE: "Adressrad 1",
					}),
				),
				Bulma.control({}, addr1.element),
			),
			Bulma.field(
				{},
				Bulma.label(
					locale.string({
						enGB: "Address line 2",
						deDE: "Adresszeile 2",
						frFR: "Adresse ligne 2",
						svSE: "Adressrad 2",
					}),
				),
				Bulma.control({}, addr2.element),
			),
			Bulma.field(
				{},
				Bulma.label(
					locale.string({
						enGB: "Postal code",
						deDE: "Postleitzahl",
						frFR: "Code postal",
						svSE: "Postnummer",
					}),
				),
				Bulma.control({}, postalCode.element),
			),
			Bulma.field(
				{},
				Bulma.label(
					locale.string({
						enGB: "Town",
						deDE: "Stadt",
						frFR: "Ville",
						svSE: "Ort",
					}),
				),
				Bulma.control({}, town.element),
			),
			Bulma.field(
				{},
				Bulma.label(
					locale.string({
						enGB: "EU VAT identification number",
						deDE: "EU-USt-IdNr.",
						frFR: "Numéro d'identification à la TVA de l'UE",
						svSE: "EU VAT-nummer",
					}),
				),
				Bulma.control({}, vatin.element),
			),
			document.createElement("hr"),

			Bulma.buttons(
				Bulma.button(
					{
						onClick: onclickCreateAccount,
						styles: ["is-primary"],
					},
					locale.strings.createAccount,
				),
				Bulma.button(
					{
						onClick: () => router.jump("/sign-in"),
						styles: ["is-primary"],
					},
					locale.strings.cancel,
				),
			),
		),
	);
}

export { createAccountPage };
